import { fetcher } from "@certn/api";
import {
  FilterChip,
  FilterChipGroup,
  GhostButton,
  Space,
  Stack,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
  useResolvedPath,
} from "react-router-dom";

import { Intro } from "./Intro";
import { Checks } from "./checks/Checks";
import { Subtitle } from "../../Subtitle";

export function Documentation() {
  const { t } = useTranslation();
  const { apiConfigurationID = "" } = useParams();

  const url = useResolvedPath("").pathname;
  const navigate = useNavigate();
  const location = useLocation();

  const checksUrl = `${url}/checks`;
  const endpointDocsUrl = `${fetcher.domain}/api/public/schema/${apiConfigurationID}/redoc/`;

  return (
    <Stack gap="space-6">
      <Subtitle subtitle={t("Documentation")} />
      <Stack orientation="horizontal">
        <FilterChipGroup>
          <FilterChip
            onChange={() => navigate(url)}
            testID="intro-link"
            isSelected={location.pathname === url}
          >
            {t("Introduction")}
          </FilterChip>
          <FilterChip
            onChange={() => navigate(checksUrl)}
            testID="checks-link"
            isSelected={location.pathname === checksUrl}
          >
            {t("Checks")}
          </FilterChip>
        </FilterChipGroup>
        <Space />
        <GhostButton
          href={endpointDocsUrl}
          onPress={() => window.open(endpointDocsUrl, "_blank")}
          rightIcon="open_in_new"
        >
          {t("API Endpoints")}
        </GhostButton>
      </Stack>
      <Routes>
        <Route path="" element={<Intro />} />
        <Route path="checks" element={<Checks />} />
      </Routes>
    </Stack>
  );
}
